module.exports = __webpack_public_path__ + "img/AmazonNew.d03aa5c8.png";